import { render, staticRenderFns } from "./CustomerReceiveParcel.vue?vue&type=template&id=65e73f74&scoped=true&"
import script from "./CustomerReceiveParcel.vue?vue&type=script&lang=js&"
export * from "./CustomerReceiveParcel.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReceiveParcel.vue?vue&type=style&index=0&id=65e73f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e73f74",
  null
  
)

export default component.exports